import * as React from 'react';
import { Notification, RouteWrapper } from '../components';

interface Props {
  children?: any;
  title: string;
}

const Route = ({
  children,
  title = 'The page you were looking for could not be found',
}: Props) => (
  <RouteWrapper title="Error">
    <div className="container">
      <Notification type="danger">{title}</Notification>
      {children}
    </div>
  </RouteWrapper>
);

export default Route;
